<!-- <app-spinner *ngIf="isLoading$ | async"></app-spinner> -->
<app-loader></app-loader>
<!-- <app-custom-table></app-custom-table> -->
<!-- <app-text-editor></app-text-editor> -->
<router-outlet></router-outlet>
<app-preview-modal></app-preview-modal>